import { Tenant as Service } from '@/services/Tenant';

const state = {
    clients_item: null,
    clients_options: null,
    clients: null,
    clients_error: null,
    users_item: null,
    user_options: null,
    users: null,
    users_error: null,
    resources_item: null,
    resources_options: null,
    resources: null,
    resources_error: null,
    scopes_item: null,
    scope_options: null,
    scopes: null,
    webhooks: null,
    webhooks_error: null,
    webhooks_item: null,
    scopes_error: null,
    roles_item: null,
    roles_options: null,
    roles: null,
    roles_error: null,
    statistics: {},
    statistics_error: null,
    keys: {},
    keys_error: null,
    keys_item: null
};
const getters = {

};

const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    }
};

const actions = {
    async createItem(context, { endpoint, data, params = {} }) {
        let response;
        try {
            response = await Service.create_item(endpoint, data, params);
        } catch (error) {
            console.error(error.response.data);
            context.commit('mutate', {
                property: `${endpoint}_error`,
                with: error.response.data
            });
            throw error;
        }
        context.commit('mutate', {
            property: `${endpoint}_item`,
            with: response
        });
        return response;
    },

    async getOptions(context, { endpoint }) {
        let response;
        try {
            response = await Service.get_options(endpoint);
        } catch (error) {
            console.error(error.response.data);
            context.commit('mutate', {
                property: `${endpoint}_error`,
                with: error.response.data
            });
            throw error;
        }
        context.commit('mutate', {
            property: `${endpoint}_options`,
            with: response
        });
        return response;
    },

    async getItem(context, { endpoint, uuid, params = {} }) {
        let response;
        try {
            response = await Service.get_item(endpoint, uuid, params);
        } catch (error) {
            console.error(error.response.data)
            context.commit('mutate', {
                property: `${endpoint}_error`,
                with: error.response.data
            });
            throw error;
        }
        context.commit('mutate', {
            property: `${endpoint}_item`,
            with: response
        });
        return response;
    },

    async getItems(context, { endpoint, params = {} }) {
        let response;
        try {
            response = await Service.get_items(endpoint, params);
        } catch (error) {
            console.error(error.response.data);
            context.commit('mutate', {
                property: `${endpoint}_error`,
                with: error.response.data
            });
            throw error;
        }
        context.commit('mutate', {
            property: `${endpoint}`,
            with: response.results
        });
        context.commit('mutate', {
            property: `${endpoint}_count`,
            with: response.count
        });
        context.commit('mutate', {
            property: `${endpoint}_next`,
            with: response.next
        });
        context.commit('mutate', {
            property: `${endpoint}_previous`,
            with: response.next
        });
        return response;
    },

    async patchItem(context, { endpoint, uuid, data, params = {} }) {
        let response;
        try {
            response = await Service.patch_item(endpoint, uuid, data, params);
        } catch (error) {
            console.error(error.response.data);
            context.commit('mutate', {
                property: `${endpoint}_error`,
                with: error.response.data
            });
            throw error;
        }
        context.commit('mutate', {
            property: `${endpoint}_item`,
            with: response
        });
        return response;
    },

    async updateItem(context, { endpoint, uuid, data, params = {} }) {
        let response;
        try {
            response = await Service.update_item(endpoint, uuid, data, params);
        } catch (error) {
            console.error(error.response.data)
            context.commit('mutate', {
                property: `${endpoint}_error`,
                with: error.response.data
            });
            throw error;
        }
        context.commit('mutate', {
            property: `${endpoint}_item`,
            with: response
        });
        return response;
    },

    async deleteItem(context, { endpoint, uuid }) {
        let response;
        try {
            response = await Service.delete_item(endpoint, uuid);
        } catch (error) {
            console.error(error.response.data)
            context.commit('mutate', {
                property: `${endpoint}_error`,
                with: error.response.data
            });
            throw error;
        }
        context.commit('mutate', {
            property: `${endpoint}_item`,
            with: null
        });
        return response;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}